"use client";

import { c as _c } from "react/compiler-runtime";
import { GDPRCookiesSettingsPanelSection } from "@/app/[lng]/_components/cookie-modal/cookie-settings-section";
import { type Dispatch, type SetStateAction, useState } from "react";
import { Trans } from "react-i18next/TransWithoutContext";
import { useTranslation } from "@/app/i18n/client";
import { sendGTMEvent } from "@/components/Tracking/TagManagerWrapper";
import { AnalyticsActions, AnalyticsCategories, AnalyticsEventType, AnalyticsLabels } from "@/constants/analytics";
import { DialogClose } from "@/components/ui/dialog";
import { useAnalyticsState } from "@/utils/hooks/use-analytics-state";
import { TFunction } from "i18next";
import { Button } from "@/components/ui/button";
export function GDPRCookiesSettings(t0) {
  const $ = _c(5);
  const {
    setShowSettingsPanel,
    acceptAllCookies,
    acceptCurrentCookies
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col flex-wrap justify-center"><GDPRCookiesSettingsPanel /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== acceptAllCookies || $[2] !== acceptCurrentCookies || $[3] !== setShowSettingsPanel) {
    t2 = <div className="flex flex-col">{t1}<GDPRCookiesSettingsFooter setShowSettingsPanel={setShowSettingsPanel} acceptAllCookies={acceptAllCookies} acceptCurrentCookies={acceptCurrentCookies} /></div>;
    $[1] = acceptAllCookies;
    $[2] = acceptCurrentCookies;
    $[3] = setShowSettingsPanel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function GDPRCookiesSettingsPanel() {
  const $ = _c(56);
  const {
    t
  } = useTranslation();
  const {
    analyticsCookie,
    setAnalyticsCookie
  } = useAnalyticsState();
  const [showRequiredDesc, setShowRequiredDesc] = useState(false);
  const [showMarketingDesc, setShowMarketingDesc] = useState(false);
  const [showStatisticsDesc, setShowStatisticsDesc] = useState(false);
  const [showSentryDesc, setShowSentryDesc] = useState(false);
  let t0;
  if ($[0] !== setAnalyticsCookie) {
    t0 = function toggleStatisticsCookie() {
      setAnalyticsCookie(_temp);
    };
    $[0] = setAnalyticsCookie;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleStatisticsCookie = t0;
  let t1;
  if ($[2] !== setAnalyticsCookie) {
    t1 = function toggleMarketingCookie() {
      setAnalyticsCookie(_temp2);
    };
    $[2] = setAnalyticsCookie;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const toggleMarketingCookie = t1;
  let t2;
  if ($[4] !== setAnalyticsCookie) {
    t2 = function toggleSentryCookie() {
      setAnalyticsCookie(_temp3);
    };
    $[4] = setAnalyticsCookie;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const toggleSentryCookie = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function toggleDescription(id) {
      bb11: switch (id) {
        case "GDPRCookies_NeededCookies":
          {
            setShowMarketingDesc(false);
            setShowStatisticsDesc(false);
            setShowSentryDesc(false);
            setShowRequiredDesc(_temp4);
            break bb11;
          }
        case "GDPRCookies_IsMarketingOn":
          {
            setShowRequiredDesc(false);
            setShowStatisticsDesc(false);
            setShowSentryDesc(false);
            setShowMarketingDesc(_temp5);
            break bb11;
          }
        case "GDPRCookies_IsStatisticsOn":
          {
            setShowRequiredDesc(false);
            setShowMarketingDesc(false);
            setShowSentryDesc(false);
            setShowStatisticsDesc(_temp6);
            break bb11;
          }
        case "GDPRCookies_IsSentryOn":
          {
            setShowRequiredDesc(false);
            setShowMarketingDesc(false);
            setShowStatisticsDesc(false);
            setShowSentryDesc(_temp7);
            break bb11;
          }
        default:
          {
            console.warn("description cannot be toggled. id '" + id + "' is not a CookieID");
          }
      }
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const toggleDescription = t3;
  let t4;
  if ($[7] !== t) {
    t4 = t("GDPRSETTINGS.DESCRIPTIONS.SETTINGSPANEL");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div className="flex-1">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("GDPRSETTINGS.SETTINGS.REQUIREDCOOKIES.TITLE");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("GDPRSETTINGS.SETTINGS.REQUIREDCOOKIES.DESCRIPTION") ?? "";
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== showRequiredDesc || $[16] !== t6 || $[17] !== t7) {
    t8 = <GDPRCookiesSettingsPanelSection id="GDPRCookies_NeededCookies" title={t6} description={t7} isDescripionExpanded={showRequiredDesc} isAllowed={true} allowChange={false} onToggle={_temp8} onToggleDescription={toggleDescription} />;
    $[15] = showRequiredDesc;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("GDPRSETTINGS.SETTINGS.STATISTICS.TITLE");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("GDPRSETTINGS.SETTINGS.STATISTICS.DESCRIPTION") ?? "";
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = analyticsCookie?.isStatisticsOn ?? false;
  let t12;
  if ($[23] !== showStatisticsDesc || $[24] !== t10 || $[25] !== t11 || $[26] !== t9 || $[27] !== toggleStatisticsCookie) {
    t12 = <GDPRCookiesSettingsPanelSection id="GDPRCookies_IsStatisticsOn" title={t9} description={t10} isDescripionExpanded={showStatisticsDesc} isAllowed={t11} allowChange={true} onToggle={toggleStatisticsCookie} onToggleDescription={toggleDescription} />;
    $[23] = showStatisticsDesc;
    $[24] = t10;
    $[25] = t11;
    $[26] = t9;
    $[27] = toggleStatisticsCookie;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("GDPRSETTINGS.SETTINGS.MARKETING.TITLE");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t) {
    t14 = t("GDPRSETTINGS.SETTINGS.MARKETING.DESCRIPTION") ?? "";
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const t15 = analyticsCookie?.isMarketingOn ?? false;
  let t16;
  if ($[33] !== showMarketingDesc || $[34] !== t13 || $[35] !== t14 || $[36] !== t15 || $[37] !== toggleMarketingCookie) {
    t16 = <GDPRCookiesSettingsPanelSection id="GDPRCookies_IsMarketingOn" title={t13} description={t14} isDescripionExpanded={showMarketingDesc} isAllowed={t15} allowChange={true} onToggle={toggleMarketingCookie} onToggleDescription={toggleDescription} />;
    $[33] = showMarketingDesc;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = toggleMarketingCookie;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t) {
    t17 = t("GDPRSETTINGS.SETTINGS.SENTRY.TITLE");
    $[39] = t;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [<a key="sentryLink" href="https://sentry.io" />];
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  const t19 = t as TFunction;
  let t20;
  if ($[42] !== t19) {
    t20 = <Trans i18nKey="GDPRSETTINGS.SETTINGS.SENTRY.DESCRIPTION" components={t18} t={t19} />;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  const t21 = analyticsCookie?.isSentryOn ?? false;
  let t22;
  if ($[44] !== showSentryDesc || $[45] !== t17 || $[46] !== t20 || $[47] !== t21 || $[48] !== toggleSentryCookie) {
    t22 = <GDPRCookiesSettingsPanelSection id="GDPRCookies_IsSentryOn" title={t17} description={t20} isDescripionExpanded={showSentryDesc} isAllowed={t21} allowChange={true} onToggle={toggleSentryCookie} onToggleDescription={toggleDescription} />;
    $[44] = showSentryDesc;
    $[45] = t17;
    $[46] = t20;
    $[47] = t21;
    $[48] = toggleSentryCookie;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t12 || $[51] !== t16 || $[52] !== t22 || $[53] !== t5 || $[54] !== t8) {
    t23 = <>{t5}{t8}{t12}{t16}{t22}</>;
    $[50] = t12;
    $[51] = t16;
    $[52] = t22;
    $[53] = t5;
    $[54] = t8;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  return t23;
}
function _temp8() {}
function _temp7(old) {
  return !old;
}
function _temp6(old_0) {
  return !old_0;
}
function _temp5(old_1) {
  return !old_1;
}
function _temp4(old_2) {
  return !old_2;
}
function _temp3(prev_1) {
  return {
    isSentryOn: !prev_1.isSentryOn
  };
}
function _temp2(prev_0) {
  return {
    isMarketingOn: !prev_0.isMarketingOn
  };
}
function _temp(prev) {
  return {
    isStatisticsOn: !prev.isStatisticsOn
  };
}
function GDPRCookiesSettingsFooter(t0) {
  const $ = _c(21);
  const {
    setShowSettingsPanel,
    acceptAllCookies,
    acceptCurrentCookies
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== setShowSettingsPanel) {
    t1 = function closeSettingsPanel() {
      setShowSettingsPanel(false);
      sendGTMEvent(AnalyticsEventType.Event, AnalyticsCategories.gdprCookiesSettings, AnalyticsLabels.button, AnalyticsActions.closeGdprCookiesSettingsClick);
    };
    $[0] = setShowSettingsPanel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeSettingsPanel = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("GDPRSETTINGS.BUTTONS.BACK");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== closeSettingsPanel || $[5] !== t2) {
    t3 = <Button onClick={closeSettingsPanel} variant="cancel">{t2}</Button>;
    $[4] = closeSettingsPanel;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("GDPRSETTINGS.BUTTONS.ACCEPT");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== acceptCurrentCookies || $[10] !== t4) {
    t5 = <DialogClose asChild={true}><Button onClick={acceptCurrentCookies} variant="submit">{t4}</Button></DialogClose>;
    $[9] = acceptCurrentCookies;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("GDPRSETTINGS.BUTTONS.ACCEPTALL");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== acceptAllCookies || $[15] !== t6) {
    t7 = <DialogClose asChild={true}><Button onClick={acceptAllCookies} variant="submit">{t6}</Button></DialogClose>;
    $[14] = acceptAllCookies;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t3 || $[18] !== t5 || $[19] !== t7) {
    t8 = <div className="flex flex-row flex-wrap justify-end gap-2 overflow-hidden">{t3}{t5}{t7}</div>;
    $[17] = t3;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}